import styled from '@emotion/styled'

const InlineBlock = styled.div`
  display: inline-block;
` 

export const Base = styled(InlineBlock)`
  color: var(--primary);
`
export const Dark = styled(InlineBlock)`
  color: var(--dark);
`

export const Bright = styled(InlineBlock)`
  color: var(--bright);
`

export const Gradient = styled.div`
  font-size: 60px;
  background: var(--linear-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`
